function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapMutations } from 'vuex';
import { localPaginationMixin } from '@/mixins/local_pagination';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import pagination from '@/components/Pagination.vue';
import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
import Somos1DataEntryService from "@/apps/customer-insigths/services/somos1_data_entry_service";
export default {
  name: 'UsersMaintenanceComponent',
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      DIALOG_ADD_SECTION: 'DIALOG_ADD_SECTION',
      DIALOG_DELETE_SECTION: 'DIALOG_DELETE_SECTION',
      keyUsersTable: 0,
      loading: false,
      item: null,
      userToAdd: '',
      search: '',
      filter_enabled: true,
      filtered_users: [],
      currentPageItems: [],
      valid: false,
      users: []
    };
  },
  created: function created() {
    var _this = this;
    this.handlePagination(pagination);
    CustomerInsightsService.getUsers().then(function (response) {
      _this.users = response.data;
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), mapActions('customer-insights')), {}, {
    onAdd: function onAdd() {
      this.$refs[this.DIALOG_ADD_SECTION].onOpen();
    },
    onOpenDialog: function onOpenDialog(item, dialogName) {
      this.item = item;
      this.$ref[dialogName].onOpen();
    },
    resetForm: function resetForm() {
      this.userToAdd = '';
      return this.$refs.formAddUser.resetValidation();
    },
    validate: function validate() {
      return this.$refs.formAddUser.validate();
    },
    onAddUser: function onAddUser(event) {
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var params = {
        user: this.userToAdd
      };
    },
    onDeleteUser: function onDeleteUser(item) {
      var _this2 = this;
      console.log(item);
      Somos1Service.revokeUserReport(item.document_id).then(function (response) {
        console.log(response);
        _this2.$toast.info('Usuario eliminado');
        _this2.getInitialData();
        _this2.keyUsersTable += 1;
      });
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    downloadUsers: function downloadUsers() {
      var _this3 = this;
      this.loading = true;
      Somos1Service.postDownloadData().then(function (response) {
        if (response) {
          var url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }));
          var link = document.createElement('a');
          link.href = url;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
          var filename = 'users-' + date + '-' + time + '.xlsx';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          _this3.loading = false;
        }
      });
    },
    getAditionalUserInfo: function getAditionalUserInfo(items) {
      var _this4 = this;
      this.filtered_users = items.filter(function (u) {
        return u.user.user_domain === '';
      });
      this.filtered_users = _toConsumableArray(new Set(this.filtered_users.map(function (u) {
        return u.user.applicant;
      })));
      console.log(this.filtered_users, 'filtered_users');
      var users_array = [];
      var promises = this.filtered_users.map(function (user) {
        _this4.isLoadingEmail = true;
        var params = {
          email: user
        };
        return UserSecurityService.getDomainRolesUser(params).then(function (response) {
          users_array.push({
            email: user,
            roles: response.data.roles,
            user_domain: response.data.user_domain
          });
        }).finally(function () {
          _this4.isLoadingEmail = false;
          // console.log(users_array, 'users_array')
          // console.log(this.items, 'this.items')
        });
      });
      Promise.all(promises).then(function () {
        _this4.items.forEach(function (i) {
          var applicant = i.user.applicant;
          var user = users_array.find(function (user) {
            return user.email === applicant;
          });
          if (user) {
            i.user.roles = user.roles;
            i.user.user_domain = user.user_domain;
          }
        });
      }).finally(function () {});
    },
    handlePagination: function handlePagination(pagination) {
      // Emite el evento manualmente para actualizar pagination.total
      this.updatePaginationTotal(pagination.itemsLength);
      var startIndex = (this.pagination.current - 1) * this.pagination.limit;
      var endIndex = startIndex + this.pagination.limit;
      this.currentPageItems = this.filteredItems.slice(startIndex, endIndex);
      this.getAditionalUserInfo(this.currentPageItems);
    },
    updatePaginationTotal: function updatePaginationTotal(total) {
      this.pagination.total = total;
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('customer-insights')), {}, {
    items: function items() {
      return this.users.map(function (user) {
        return {
          user: user
        };
      });
    },
    headers: function headers() {
      return [{
        value: 'user.applicant',
        text: 'Usuario'
      }, {
        value: 'user.report.name',
        text: 'Reporte'
      }, {
        value: 'user.user_type',
        text: 'Tipo de Usuario'
      }, {
        value: 'user.roles',
        text: 'Roles'
      }, {
        value: 'user.user_domain',
        text: 'Empresa'
      }, {
        value: 'actions',
        text: ''
      }];
    },
    filteredItems: function filteredItems() {
      var _this5 = this;
      return this.items.filter(function (item) {
        return item.user.applicant.toLowerCase().includes(_this5.search.toLowerCase());
      });
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  })
};